export const SfImgIcon = ({
  imageName,
  width = '24px',
  height = '24px',
}: {
  imageName: string;
  width?: string;
  height?: string;
}) => {
  return (
    <img style={{ width, height }} src={`/icons/salesforce/${imageName}.svg`} alt={imageName} />
  );
};
